export const IconPlay = () => {
    return (
        <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.3691 4.80455C15.3691 7.11395 17.3691 8.26865 17.3691 10.0007C17.3691 11.7328 15.3691 12.8875 11.3691 15.1969L9.73278 16.1416C5.73278 18.451 3.73278 19.6057 2.23278 18.7397C0.73278 17.8737 0.73278 15.5643 0.73278 10.9455L0.73278 9.05594C0.73278 4.43714 0.73278 2.12774 2.23278 1.26172C3.73278 0.39569 5.73278 1.55039 9.73278 3.85979L11.3691 4.80455Z" fill="#262626" />
        </svg>

    )
}